import { useEffect } from 'react';
import vConsole from 'vconsole';
var useSingleVConsole = function useSingleVConsole() {
  useEffect(function () {
    setTimeout(function () {
      if (BUILD_ENV !== 'pro' && document.getElementById('__vconsole') === null) {
        new vConsole();
      }
    }, 1000);
  }, []);
};
export default useSingleVConsole;